export default __webpack_public_path__ + "static/media/Mint.22af8075.svg";